import React, { memo } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Button from '@material-ui/core/Button';
import { useDispatch, useSelector } from 'react-redux';
import { actionCreators as selfServiceActionCreators } from './../redux/actions/selfServiceActions';
import { useParams } from 'react-router-dom';

const buttonsStyle = {
	fontSize: '11px',
	margin: '5px',
};

const containerStyle = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	maxWidth: '100%',
	marginLeft: '10px',
};

const EntityFilePicker = (props) => {
	const { field, document, addingMode } = props;

	const dispatch = useDispatch();
	const allParams = useParams();
	const documentsSettings = useSelector((state) => state.staticData.documentSettings);
	const isLoading = useSelector((state) => state.selfService.isWaitingRequest);
	const hiddenFileInput = React.useRef(null);
	const setFieldError = props.setFieldError;
	const [reloadState, setReloadState] = React.useState(null);

	const getDocumentV2FromUploadedFile = (fileUploaded) => {
		return {
			DocumentTypeID: field.FieldCode.replace('Document', ''),
			DocumentName: field.FieldName,
			UploadedFileName: fileUploaded.name,
			Extension: getDocumentExtension(fileUploaded.name),
		};
	};

	const getDocumentExtension = (documentName) => {
		const nameSplitted = documentName.split('.');
		return nameSplitted.length > 0 ? '.' + nameSplitted[nameSplitted.length - 1] : '';
	};


	const handleUploadButtonClick = (event) => {
		hiddenFileInput.current.click();
	};

	const isSelfServiceFile = () => !!document?.IsSelfService;

	const validateDocument = (file, settings) => {
		if (!file) return;
		const ext = getDocumentExtension(file.name);
		const sizeError = 'File size cannot be bigger than ' + settings.MaxFileUpload + 'kb.';
		let errorMessage = settings.AllowedFileTypes.some(x => x.toLocaleLowerCase() === ext.toLocaleLowerCase()) ? '' : 'Extension is not valid';

		errorMessage =
			file.size < settings.MaxFileUpload * 1000
				? errorMessage
				: errorMessage
					? errorMessage + 'and ' + sizeError
					: 'File size is too big.';

		if (file.name.length > 100) {
			errorMessage = 'File name is too long. Maximum 100 characters allowed.';
		}

		return errorMessage;
	};

	const handleDocumentPickerChange = (event) => {
		const errorMessage = validateDocument(event.target.files[0], documentsSettings);
		if (!errorMessage) {
			saveDocument(event.target.files[0]);
		} else alert(errorMessage);
	};

	const downloadFile = () => {
		setFieldError(null);
		dispatch(
			selfServiceActionCreators.requestDocument(allParams.entityId, document.BaseDocumentId)
		).catch((error) => {
			setFieldError(error.ErrorMessage ? error.ErrorMessage : error);
		});
	}
	const deleteDocument = () => {
		setFieldError(null);
		dispatch(
			selfServiceActionCreators.deleteDocument(allParams.entityId, field.FieldCode, document.BaseDocumentId)
		).catch((error) => {
			setFieldError(error.ErrorMessage ? error.ErrorMessage : error);
		});

		hiddenFileInput.current.files = null;
		hiddenFileInput.current.value = '';
		setReloadState((state) => !state);
	};
	const saveDocument = (fileUploaded) => {
		hiddenFileInput.current.value = '';
		hiddenFileInput.current.files = null;
		setFieldError(null);
		setReloadState((state) => !state);
		dispatch(
			selfServiceActionCreators.uploadDocument(
				allParams.entityId,
				field.InternalName,
				fileUploaded,
				getDocumentV2FromUploadedFile(fileUploaded)
			)
		).catch((error) => {
			setFieldError(error.ErrorMessage ? error.ErrorMessage : error);
		});
	};
	return (
		<>
			<div style={containerStyle}>
				<div style={{ ...buttonsStyle, textAlign: 'start' }}>{isSelfServiceFile() && document.UploadedFileName}</div>
				<div style={{ marginLeft: '30px' }}>
					{addingMode && (
						<Button
							style={{ ...buttonsStyle, marginTop: `50px` }}
							variant='contained'
							color='primary'
							size='small'
							onClick={handleUploadButtonClick}
							disabled={!!document || isLoading}
							startIcon={<CloudUploadIcon />}
						>
							Upload File
						</Button>
					)}
					<input
						type='file'
						ref={hiddenFileInput}
						onChange={handleDocumentPickerChange}
						style={{ display: 'none' }}
					></input>

					{!addingMode && (
						<Button
							style={buttonsStyle}
							variant='contained'
							color='primary'
							size='small'
							onClick={downloadFile}
							disabled={!document || isLoading}
							startIcon={<CloudDownloadIcon />}
						>
							Download File
						</Button>
					)}
					{isSelfServiceFile() && (
						<Button
							style={buttonsStyle}
							variant='contained'
							color='secondary'
							size='small'
							disabled={!isSelfServiceFile() || isLoading}
							onClick={deleteDocument}
							startIcon={<DeleteIcon />}
						>
							Remove File
						</Button>
					)}
				</div>
			</div>
		</>
	);
};

export default memo(EntityFilePicker);
